import { takeEvery, put, select } from 'redux-saga/effects';
import { terminateTxnOpps, unterminateTxnOpps, appNotify, setChannelWorkflowLoadingOverlayState } from 'store/actions';
import { putWithTokenV2 } from 'api/network';
import { userSelector } from 'store/selectors';

export function* terminateTxnOppsSaga() {
  yield takeEvery(terminateTxnOpps, function* ({ payload }) {
    const { transactionOpportunityIds, reason } = payload;
    try {
      const req = {
        transactionOpportunityIds,
        reason
      }
      const user = yield select(userSelector);
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Terminating Transaction Opportunity...' }));
      yield putWithTokenV2(`/api/underwrite/workflow/tasks/terminate?userId=${user.id}`, req)

      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify('Update success', 'success'));
    } catch (error) {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });

  yield takeEvery(unterminateTxnOpps, function* ({ payload }) {
    const { txnOppIds } = payload;
    try {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: true, message: 'Unterminating Transaction Opportunity...' }));
      yield putWithTokenV2(`/api/underwrite/workflow/tasks/unterminate`, txnOppIds)

      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify('Update success', 'success'));
    } catch (error) {
      yield put(setChannelWorkflowLoadingOverlayState({ isLoading: false, message: null }));
      yield put(appNotify(error.message, 'error'));
    }
  });
}

